<script lang="ts" setup>
import PlayerSearchCreateForm from './PlayerSearchCreateForm.vue'

const { group } = defineProps<{
  tournament: Tournament
  group: TournamentGroup
}>()

const emit = defineEmits<{ close: [] }>()
</script>

<template>
  <UiDialog
    :open="true"
    @update:open="emit('close')"
  >
    <UiDialogContent
      :title="$t('Add player to group')"
    >
      <UiAlert
        :title="$t('Warning')"
        :description="$t('This will add the player to the group. This is irreversible.') + ' ' + $t('The group will be updated to the format of the new size') + ' ' + $t('If a game is ongoing, notify the players (and refresh the tablet app)')"
        variant="warning"
      />
      <PlayerSearchCreateForm
        :tournament="tournament"
        :on-save="() => { emit('close') }"
        :can-add-players="true"
        :group="group"
      />
    </UiDialogContent>
  </UiDialog>
</template>
